/**
 * Who the list belongs to, as Minha Lista writes it.
 *
 * The backend keeps the two hosts on the list itself (`personName1`, `personName2`). The
 * prototype writes them whole over the hero ("Maria Helena Almeida & João Pedro Ribeiro") and by
 * first name over the grid ("A lista de Maria e João"). A list that names nobody yet falls back
 * to the account's own name; with nobody known at all, both come back empty and the screen
 * renders no name.
 */
export function listHosts(
  list: { personName1?: string | null; personName2?: string | null },
  accountName: string,
): { hostsTitle: string; hostsShort: string } {
  const named = [list.personName1, list.personName2]
    .map((name) => (name ?? "").trim())
    .filter((name) => name !== "");
  const hosts = named.length > 0 ? named : [accountName.trim()].filter((name) => name !== "");

  return {
    hostsTitle: hosts.join(" & "),
    hostsShort: hosts.map((name) => name.split(/\s+/)[0]).join(" e "),
  };
}
